import {
  IconClockAlt,
  IconGift,
  IconMoney,
  IconProfile,
} from '@leland-dev/leland-ui-library';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React, { type ReactElement } from 'react';

import { LexSlug, useLex } from '../../context/LexContext';
import { ORDER_HISTORY_URL } from '../../utils/constants';

const ICON_CLASSNAME = 'text-leland-gray-dark w-6 h-6';

const SettingsNavigationSidebar = () => {
  const { isLexEnabled } = useLex();
  return (
    <div className="hidden flex-col justify-start gap-2 p-4 sm:flex sm:min-w-56 sm:max-w-56 sm:border-r sm:p-2">
      <SidebarLinkSection
        label="Profile"
        mainHref="/settings/profile"
        icon={<IconProfile className={ICON_CLASSNAME} />}
      />
      {isLexEnabled(LexSlug.FEATURE_CUSTOMER_REFERRAL) ? (
        <SidebarLinkSection
          label="Refer a friend"
          mainHref="/referrals"
          icon={<IconGift className={ICON_CLASSNAME} />}
        />
      ) : null}
      <SidebarLinkSection
        label="Order History"
        mainHref={ORDER_HISTORY_URL}
        icon={<IconClockAlt className={ICON_CLASSNAME} />}
      />
      <SidebarLinkSection
        label="Payment Details"
        mainHref="/settings/payment-details"
        icon={<IconMoney className={ICON_CLASSNAME} />}
      />
    </div>
  );
};

interface SidebarLinkSectionProps {
  label: string;
  mainHref: string;
  icon: ReactElement;
}

const SidebarLinkSection: React.FC<SidebarLinkSectionProps> = ({
  label,
  mainHref,
  icon,
}) => {
  const router = useRouter();

  const isActiveSection = router.pathname.startsWith(mainHref);

  return (
    <Link
      href={mainHref}
      className={`flex w-full rounded-lg px-3 py-4 text-lg font-medium text-leland-gray-dark hover:bg-leland-gray-hover active:bg-leland-gray-hover sm:p-3 ${
        isActiveSection ? 'bg-leland-gray-hover' : ''
      }`}
    >
      <div className="flex w-full items-center justify-start text-left">
        <div className="relative flex items-center">{icon}</div>
        <span className="ml-4 whitespace-nowrap">{label}</span>
      </div>
    </Link>
  );
};

export default SettingsNavigationSidebar;
